export interface TableButtonProps {
  tableId: string;
  tableDeleted: boolean;
}

export enum ButtonType {
  PROFITS,
  BOT_ERRORS,
  CHAT,
  HISTORY,
  LOGS,
  PIN_TABLE,
  MODAL_WINDOW,
  WAITLIST,
  WAITING_HOST_BOTS,
  CLOSE_TABLE,
}

export const allButtonTypes: ButtonType[] = Object.keys(ButtonType).map(
  key => ButtonType[key],
);

export const buttonTypesExpertMode: ButtonType[] = [
  ButtonType.PROFITS,
  ButtonType.BOT_ERRORS,
  ButtonType.CHAT,
  ButtonType.HISTORY,
  ButtonType.WAITLIST,
  ButtonType.WAITING_HOST_BOTS,
  ButtonType.CLOSE_TABLE,
];

export const buttonTypesModalWindow: ButtonType[] = [
  ButtonType.PROFITS,
  ButtonType.BOT_ERRORS,
  ButtonType.CHAT,
  ButtonType.HISTORY,
  ButtonType.LOGS,
  ButtonType.PIN_TABLE,
  ButtonType.WAITLIST,
  ButtonType.WAITING_HOST_BOTS,
];
